<!-- old-color-palatte-top -->
<div
  class="one3d-color-palette"
  [ngClass]="{ 'one3d-color-palette-active': menuVisible }"
>
  <div
    class="one3d-color-wrapper"
    [attr.data-color]="colorSelected?.color_name"
  >
    <span
      *ngFor="let color of colors"
      (click)="selectColor(color)"
      class="one3d-colors one3d-colors-single-tone"
      (mouseenter)="showTooltip($event)"
      (mouseleave)="hideTooltip()"
      [attr.data-color]="color.color_name"
    >
      <img
        class="one3d-center-xy"
        *ngIf="color?.variant_color_id == this.colorSelected?.variant_color_id"
        src="assets/img/icons/one3d-color-check.svg"
        alt="color-checked icon"
      />
      <span
        class="one3d-colors-dual-tone"
        [ngStyle]="{ background: returnColor(color.color_code) }"
      ></span>
      <span
        class="one3d-colors-dual-tone"
        [ngStyle]="{ background: returnDualToneColor(color.color_code) }"
      ></span>
    </span>
  </div>
</div>
<!-- <div class="tooltip" *ngIf="tooltipVisible">{{ tooltipContent }}</div> -->
<div class="tooltip" [style.top]="tooltipTop + 'px'" *ngIf="tooltipVisible">
  {{ tooltipContent }}
</div>
